var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('Card',{attrs:{"model":_vm.model,"time":_vm.time,"emitter":_vm.emitter,"filters":_vm.filters,"panel":_vm.panel,"filterOthers":_vm.filterOthers,"resourceType":_vm.resourceType,"dataJobId":_vm.dataJobId,"dataTaskId":_vm.dataTaskId,"workerId":_vm.workerId,"consoleId":_vm.consoleId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }